import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { flexCenterVertical } from '@stylesheets/helpers';
import { SIDEBAR_INSET } from '@constants/sidebar';
import { duration } from '@stylesheets/motion';

export const Container = styled.div`
  position: relative;
  flex-shrink: 0;
  margin: 31px ${SIDEBAR_INSET}px 0;
`;

export const Trigger = styled.button`
  ${flexCenterVertical}
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  height: 40px;
  padding: 0 16px;

  ${({ theme: { spacing, colors, borderRadius } }) => css`
    gap: ${spacing.level3};
    border-radius: ${borderRadius.full};
    color: ${colors.onSurface};
    transition: background-color ${duration.fast} ease;

    &:hover,
    &[aria-expanded='true'] {
      background-color: ${colors.surfaceContainerHigh};
    }

    &:focus-visible {
      outline: 2px solid ${colors.primary};
      outline-offset: 2px;
    }
  `}
`;

export const TriggerLabel = styled.span`
  text-align: left;
  font-family: ${({ theme: { font } }) => font.titleMedium.fontFamily}, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  white-space: nowrap;
`;

export const TriggerContent = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const ChevronIcon = styled.span<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  transition: transform 0.2s ease;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '180deg' : '0deg')});
  color: ${({ theme: { colors } }) => colors.onSurfaceVariant};
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 100;

  ${({ theme: { spacing, borderRadius, colors } }) => css`
    padding: ${spacing.level2};
    border-radius: ${borderRadius.large};
    background-color: ${colors.surfaceContainer};
    border: 1px solid ${colors.outlineVariant};
    box-shadow: 0 4px 16px ${rgba(colors.shadow, 0.24)};
  `}
`;

export const DropdownItem = styled.button<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s ease;

  ${({ theme: { spacing, borderRadius, font, colors }, $isActive }) => css`
    gap: ${spacing.level3};
    padding: ${spacing.level3} ${spacing.level5};
    border-radius: ${borderRadius.full};
    font-family: ${font.bodyMedium.fontFamily}, sans-serif;
    font-size: ${font.bodyMedium.fontSize};
    font-weight: ${font.bodyMedium.fontWeight};
    line-height: ${font.bodyMedium.lineHeight};
    background-color: ${$isActive ? colors.secondaryContainer : 'transparent'};
    color: ${$isActive ? colors.onSecondaryContainer : colors.onSurface};

    &:hover {
      background-color: ${$isActive
        ? colors.secondaryContainer
        : colors.surfaceContainerHigh};
    }
  `}
`;

export const Divider = styled.hr`
  border: none;
  height: 1px;

  ${({ theme: { spacing, colors } }) => css`
    margin: ${spacing.level2} ${spacing.level4};
    background-color: ${colors.outlineVariant};
  `}
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99;
`;
